"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRegionHrefsOrDefault;

var _defaultRegionHrefs = _interopRequireDefault(require("./defaultRegionHrefs"));

// import { useRouteData } from 'react-static';
function useRegionHrefsOrDefault() {
  // const { regionHrefs } = useRouteData();
  // return { ...defaultRegionHrefs, ...regionHrefs };
  return _defaultRegionHrefs.default;
}